export default __webpack_public_path__ + "static/media/txtIcon.25f1532d.svg";